import { multiply, addIndex, forEach, compose, map, prop, equals, head, __ } from 'ramda';
import React from 'react';
import ReactDOM from 'react-dom';
import autoBind from '../../modules/autoBind';
import xtnaTrabajoTemplate from '../assets/XtnaTrabajoChart.png';

const colors = {
  red: 'rgb(255, 0, 0)',
  blue: 'rgb(0, 0, 255)',
  black: 'rgb(0, 0, 0)',
};

export default class XTNATrabajoChart extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { canvas: null, backgroundLoaded: false };
  }
  componentDidMount() {
    const canvas = document.createElement('canvas');
    canvas.setAttribute('style', 'width: 100%; height: 100%;');
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth);
    canvas.setAttribute('id', this.props.id);
    ReactDOM.findDOMNode(this).appendChild(canvas);
    const background = new Image();
    background.src = xtnaTrabajoTemplate;
    background.onload = () => this.setState({ backgroundLoaded: true });
    this.setState({ canvas, background });
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    ReactDOM.findDOMNode(this).removeChild(this.state.canvas);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }
  render() {
    if (this.state.canvas && this.state.backgroundLoaded) {
      this.renderCanvas(this.state.canvas);
    }
    
    return <div style={{ marginBottom: '10px' }}></div>;
  }
  renderCanvas(canvas) {
    canvas.setAttribute('width', canvas.offsetWidth);
    canvas.setAttribute('height', canvas.offsetWidth * .682);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(this.state.background, 0, 0, canvas.offsetWidth, canvas.offsetHeight);   

    const width = multiply(canvas.offsetWidth);
    const height = multiply(canvas.offsetWidth);

    const yPositions = [.044, .214, .382, .545];
    const xPositions = [.073, .193, .319, .45, .5, .55, .633, .763, .907];
    const natural = ['NX', 'NT', 'NN', 'NA'];
    const adapted = ['AX', 'AT', 'AN', 'AA'];

    for (let j = 0; j < 4; j++) {
      const xPosN = xPositions[9 - this.props[natural[j]]];
      const xPosA = xPositions[9 - this.props[adapted[j]]];
      const yPos = yPositions[j];

      // draw circles
      ctx.strokeStyle = colors.red;
      ctx.lineWidth = 5;

      ctx.beginPath();
      ctx.arc(width(xPosN), height(yPos), width(.025), 0, 2*Math.PI);
      ctx.closePath();
      ctx.stroke();

      // draw triangles
      ctx.strokeStyle = colors.blue;
      ctx.beginPath();
      ctx.moveTo(width(xPosA) - width(.023), height(yPos) + width(.018));
      ctx.lineTo(width(xPosA) + width(.002), height(yPos) - width(.032));
      ctx.lineTo(width(xPosA) + width(.0257), height(yPos) + width(.018));
      ctx.lineTo(width(xPosA) + width(.002), height(yPos) + width(.018));
      ctx.closePath();
      ctx.stroke();

      const xOffsetN = (xPosN < xPosA ? 1 : xPosN > xPosA ? -1 : 0) * .029;
      const xOffsetA = (xPosN < xPosA ? -1 : xPosN > xPosA ? 1 : 0) * .017;

      // draw lines
      ctx.lineWidth = 4;
      ctx.strokeStyle = colors.black;
      ctx.dashedLine(width(xPosN + xOffsetN), height(yPos), width(xPosA + xOffsetA), height(yPos), 6);
    }

  }
}



// WEBPACK FOOTER //
// ./src/App/xtnaTrabajo/Chart.jsx